import type { SpriteSheetType } from "@certa/icons";
import _spriteSheet from "@certa/icons/spritesheet";
import type { TextureSource } from "pixi.js";
import * as PIXI from "pixi.js";

const { spriteSheetSVGData, iconSequence, iconSize, padding } =
  _spriteSheet as SpriteSheetType;

const DEFAULT_SCALING = 3;
export const DEFAULT_ICON_SIDE_LENGTH = iconSize * DEFAULT_SCALING;
const DEFAULT_ICON_SIDE_LENGTH_WITH_PADDING =
  (iconSize + 2 * padding) * DEFAULT_SCALING;

const svgRes = new PIXI.SVGResource(spriteSheetSVGData, {
  scale: DEFAULT_SCALING
});
const texture = PIXI.Texture.from(svgRes as unknown as TextureSource);

const blankTexture = new PIXI.Texture(
  texture.baseTexture,
  new PIXI.Rectangle(0, 0, 1, 1)
);

// This function takes in an icon name and returns a PIXI.Sprite
// with the icon as its texture.
// Params
// iconName: string - The name of the icon to be returned
// options: { height?: number; width?: number } - An optional object
export function loadIcon(iconName: string) {
  // Find the index of the icon in the iconSequence array
  const iconIndex = iconSequence.findIndex(icon => icon === iconName);
  if (iconIndex === -1) {
    return blankTexture;
  }
  /**
   * We need to create a new texture because
   * we need to "frame" the texture to position the appropriate
   * icon in the spritesheet.
   *
   * Reusing same texture will cause
   * all icons to be the same because they're sharing the same
   * reference to the texture whose frame is being changed.
   */
  const finalTexture = new PIXI.Texture(
    texture.baseTexture,
    new PIXI.Rectangle(
      iconIndex === 0
        ? 0
        : DEFAULT_ICON_SIDE_LENGTH_WITH_PADDING * iconIndex +
          // 1px is the extra padding on left and right side of icons,
          // therefore we offset it by 1px
          // But since we're dealing with scaled icons, the 1px has to be
          // adjusted according to scaling and hence we do
          // 1 * DEFAULT_SCALING
          1 * DEFAULT_SCALING,
      0,
      DEFAULT_ICON_SIDE_LENGTH,
      DEFAULT_ICON_SIDE_LENGTH
    )
  );

  return finalTexture;
}
